import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React from 'react';
import { decodeColors } from '@/utils/colors';
import { getEditingAreaAttr, getEditingAreaMetaDataAttr } from '@/components/Editor/hooks/useEditingAreas';
import styles from '../styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Item = _ref => {
  let {
    label,
    hasSeparator,
    value,
    text,
    isLast,
    color,
    selection = '',
    selectionIndex = -1,
    editing = false
  } = _ref;
  const [positiveColor, negativeColor] = decodeColors(color);
  const isNegative = typeof value === 'number' ? value < 0 : false;
  const isPositive = typeof value === 'number' ? value > 0 : false;
  const finalColor = Boolean(isNegative && negativeColor) && negativeColor || Boolean(isPositive && positiveColor) && positiveColor || '';
  return /*#__PURE__*/_jsxs("li", _objectSpread(_objectSpread(_objectSpread({
    className: clsx(styles.item, hasSeparator && styles['item--separator'], isLast && styles['item--summary']),
    style: _objectSpread({}, finalColor && {
      color: finalColor
    })
  }, editing && selectionIndex > -1 && {
    [getEditingAreaAttr()]: `item-${selectionIndex}`
  }), editing && {
    [getEditingAreaMetaDataAttr()]: JSON.stringify({
      selection,
      selectionIndex
    })
  }), {}, {
    children: [/*#__PURE__*/_jsx("span", {
      className: styles.label,
      dangerouslySetInnerHTML: {
        __html: label
      }
    }), /*#__PURE__*/_jsx("span", {
      className: styles.text,
      dangerouslySetInnerHTML: {
        __html: text
      }
    })]
  }));
};

export default Item;